import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-content container">
        <div className="row">
          <div className="col-lg-5">
            <h2>JBJM AI and Cloud Pvt Ltd</h2>
            <div className="social-icons">
              <span><i className="fab fa-instagram"></i></span>
              <span><i className="fab fa-facebook"></i></span>
              <span><i className="fab fa-google-plus-square"></i></span>
              <span><i className="fab fa-twitter-square"></i></span>
            </div>
          </div>

          <div className="col-lg-4 footer-text">
            <h5>LOCATION</h5>
            <p>
              <b>Address:</b> IT-7 Building, Qubix Business Parks, <br />
              Phase 1, Hinjawadi, Pune, Maharashtra 411057.
            </p>
            <p><b>Contact Number:</b> +91-8805544789</p>
          </div>

          <div className="col-lg-3 footer-text">
            <h5>CONTACT</h5>
            <p>
              <b>Email:</b>{" "}
              <Link to="mailto:support@jbjmaicloud.com" className="redirect">
                support@jbjmaicloud.com
              </Link>
              <br />
              <Link to="mailto:hr@jbjmaicloud.com" className="redirect">
                hr@jbjmaicloud.com
              </Link>
            </p>
            <p>
              <b>Website:</b>{" "}
              <Link to="http://www.jbjmaicloud.com" className="redirect">
                www.jbjmaicloud.com
              </Link>
            </p>
          </div>

          
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 JBJM AI and Cloud Pvt Ltd. All Rights Reserved.</p>
        <div className="footer-links">
          <Link to="#">Cookie Preferences</Link> /{" "}
          <Link to="#">Cookie Declaration</Link> /{" "}
          <Link to="#">Privacy Policy</Link>/{" "}
          <Link to="#">Feedback</Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
